<template>
  <div class="turntable_container">
    <div class="turntable_box">
      <div class="turntable_title_img">
        <img :src="require('@/assets/images/raffle/dzp_title.png')" alt="">
      </div>
      <div class="turntable_mine_box">
        <div class="turntable_bg">
          <img :src="require('@/assets/images/raffle/dzp_bg.png')" alt="">
        </div>
        <canvas class="turntable_canvas" id="wheelcanvas" width="422px" height="422px"></canvas>
        <div class="turntable_point">
          <img :src="require('@/assets/images/raffle/dzp_point.png')" alt="">
        </div>
        <div class="turntable_btn" @click="startRaffle">
          <div class="name">抽奖</div>
          <div class="tips">您有<span class="remain_times" v-text="remainTime"></span>次抽奖机会</div>
        </div>
      </div>
      <div class="my_prize_btn" @click="showMyPrizeHandler">
        <img :src="require('@/assets/images/raffle/dzp_my_prize.png')" alt="">
      </div>
      <div class="operate_box">
        <span class="operate_btn"><span @click="showAwards=true">奖项设置</span></span>
        <span class="operate_btn"><span @click="showRules=true">抽奖规则</span></span>
      </div>
    </div>
    <!-- 我的奖品 -->
    <van-popup :style="{ width: '80%', height: '351px', overflow: 'hidden', backgroundColor: '#fff9d9', borderRadius: '10px' }" v-model="showMyPrize" v-if="!!detail">
      <div class="my_prize_box">
        <div class="my_prize_title">我的奖品</div>
        <span class="close" @click="showMyPrize=false">
          <Icon iconClass="close_round" />
        </span>
        <div class="prize_table_title">
          <span class="time">中奖时间</span>
          <span class="name">奖品</span>
          <span class="btn_span">兑奖</span>
        </div>
        <div class="prize_content">
          <ul class="prize_list">
            <li class="prize_item" v-for="(item,index) in myPrizeList" :key="index">
              <span class="time" v-text="item.drawTime.substring(0,10)"></span>
              <span class="name" v-text="item.awardName"></span>
              <span class="btn_span" v-if="item.luckerStatus==0">
                <span class="btn btn_recipient" v-if="item.addressee.length>0 && item.expressPhone.length>0 && item.expressAddress.length>0" @click="recipientInfo(item)">查看</span>
                <span class="btn" @click="showAcceptHandler(item)" v-else>兑奖</span>
              </span>
              <span class="btn_span" v-else-if="item.luckerStatus==1">
                <span class="btn btn_dis">已兑</span>
              </span>
              <span class="btn_span" v-else><span class="btn btn_dis">放弃</span></span>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
    <!-- 兑奖 -->
    <van-popup :style="{ width: '80%', height: 'auto', overflow: 'hidden', backgroundColor: '#fff9d9', borderRadius: '10px' }" v-model="showAccept">
      <div class="dj_box">
        <van-tabs class="tabbar" @click="onDJTabClick" :line-width="'60px'">
          <van-tab title="现场兑奖"></van-tab>
          <van-tab title="邮寄奖品"></van-tab>
        </van-tabs>
        <div class="dj_content">
          <div class="mail_address_box" v-if="isMail">
            <p class="inputInfoTitle">请输入收件信息</p>
            <div class="recipientName">
              <label>收件人：</label>
              <input class="nameInput" autocomplete="off" v-model="curPrize.addressee" type="text" placeholder="请输入收件人姓名">
            </div>
            <div class="phoneDiv">
              <label>手机号：</label>
              <input class="phoneInput" autocomplete="off" v-model="curPrize.expressPhone" type="text" placeholder="请输入手机号号码">
            </div>
            <div class="recipientAddress">
              <label>收件地址：</label>
              <input class="addressInput" autocomplete="off" v-model="curPrize.expressAddress" type="text" placeholder="请输入收件地址">
            </div>
            <span class="submitTijiao" @click="acceptPrizeByMail">确定</span>
          </div>
          <div class="prize_code_box" v-else>
            <p class="inputInfoTitle">请输入兑奖码</p>
            <div class="prizeCode">
              <label>兑奖码：</label>
              <input class="codeInput" type="text" v-model="prizeCode" placeholder="请输入兑奖码">
            </div>
            <div class="tips">注：兑奖码可与主办方沟通获得！</div>
            <span class="submitTijiao" @click="acceptPrizeByCode">确定</span>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 奖项设置 -->
    <van-popup :style="{ width: '80%', height: '72%', overflow: 'hidden', backgroundColor: '#fff9d9', borderRadius: '10px' }" v-model="showAwards" v-if="!!detail">
      <div class="awards_box">
        <div class="awards_title">奖项设置</div>
        <span class="close" @click="showAwards=false">
          <Icon iconClass="close_round" />
        </span>
        <div class="award_content">
          <ul class="award_list">
            <li class="award_item" v-for="(item,index) in awards" :key="index">
              <div class="award_title"><span v-text="index+1"></span>）<span v-text="item.awardName"></span></div>
              <div class="award_img">
                <img :src="item.resourceUrl" alt="">
              </div>
              <div class="award_description" v-text="item.details"></div>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
    <!-- 抽奖规则 -->
    <van-popup :style="{ width: '80%', height: '72%', overflow: 'hidden', backgroundColor: '#fff9d9', borderRadius: '10px' }" v-model="showRules" v-if="!!detail">
      <div class="rules_box">
        <div class="rules_title">抽奖规则</div>
        <span class="close" @click="showRules=false">
          <Icon iconClass="close_round" />
        </span>
        <div class="rule_content" v-html="detail.details"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepClone, testMobilePhone } from "@/utils";
import raffleApi from "@/api/apis/raffle.js";
export default {
  name: "Turntable",
  props: {
    detailInfo: {
      type: Object,
      default: null,
    },
    freeFlag: {
      type: Number,
      default: 0,
    },
    awards: {
      type: Array,
      default: [],
    },
  },
  watch: {
    detailInfo: {
      handler(newValue, oldValue) {
        if (!!newValue) {
          this.detail = deepClone(newValue);
          this.raffleId = this.detail.id;
          if (this.freeFlag == 1) {
            this.remainTime = 1;
          } else {
            this.getRaffleTimes();
          }
        }
      },
      deep: true,
    },
    awards: {
      handler(newValue, oldValue) {
        if (!!newValue && newValue.length > 0) {
          this.initRaffle();
        }
      },
      deep: true,
    }
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  data() {
    return {
      detail: null, // 详情
      raffleId: 0, // 抽奖Id
      remainTime: 0, // 抽奖剩余次数
      failedMsg: ['谢谢参与', '再接再厉', '不要灰心', '祝您好运', '加油加油'], // 未中奖提示语
      failedMsg2: ['很遗憾，什么都没抽到！', "不要灰心，加油加油！", "谢谢参与，祝您好运！"], // 未中奖弹窗提示语
      colors: ["#feca4e", "#feec6e"], // 大转盘背景色
      /* 旋转圆盘配置 */
      turnplate: {
        prizeNames: [], //大转盘奖品名称
        colors: [], //大转盘奖品区块对应背景颜色
        outsideRadius: 192, //大转盘外圆的半径
        textRadius: 155, //大转盘奖品位置距离圆心的距离
        insideRadius: 68, //大转盘内圆的半径
        startAngle: 0, //开始角度
        bRotate: false, //false:停止; true:旋转
        rNum: 0, // 旋转圈数基数
      },
      oTurntable: null, //旋转圆盘
      timer: null, //定时器
      showMyPrize: false, // 显示我的奖品
      myPrizeList: [], // 我的中奖记录
      showAwards: false, // 显示奖项
      showRules: false, // 显示抽奖规则
      showAccept: false, // 显示兑奖弹窗
      isMail: false, // 是否邮寄，默认现场兑奖
      curPrize: null, // 当前的兑奖数据
      prizeCode: "", // 兑奖码
    };
  },
  methods: {
    /** 初始化大转盘 **/
    initRaffle() {
      var _this = this;
      var len = _this.awards.length;
      var prizeNames = [];
      var backColors = [];
      if (len == 0) {
        return;
      } else if (len == 1) {
        prizeNames = [_this.awards[0].awardName, _this.failedMsg[0], _this.failedMsg[1], _this.failedMsg[2]];
        backColors = [_this.colors[0], _this.colors[1], _this.colors[0], _this.colors[1]];
      } else if (len >= 2) {
        for (var i = 0; i < len; i++) {
          prizeNames.push(_this.awards[i].awardName);
          backColors.push(_this.colors[0]);
          prizeNames.push(_this.failedMsg[i % 5]);
          backColors.push(_this.colors[1]);
        }
      }

      _this.turnplate.prizeNames = prizeNames;
      _this.turnplate.colors = backColors;

      /** 绘制大转盘 start **/
      var canvas = document.getElementById("wheelcanvas");
      //根据奖品个数计算圆周角度
      var arc = Math.PI / (_this.turnplate.prizeNames.length / 2);
      var ctx = canvas.getContext("2d");
      //在给定矩形内清空一个矩形
      ctx.clearRect(0, 0, 422, 422);
      //strokeStyle 属性设置或返回用于笔触的颜色、渐变或模式
      ctx.strokeStyle = "#FFBE04";
      //font 属性设置或返回画布上文本内容的当前字体属性
      ctx.font = '16px Microsoft YaHei';

      /** For start **/
      for (var i = 0; i < _this.turnplate.prizeNames.length; i++) {
        var angle = _this.turnplate.startAngle + i * arc;
        ctx.fillStyle = _this.turnplate.colors[i];
        ctx.beginPath();
        //arc(x,y,r,起始角,结束角,绘制方向) 方法创建弧/曲线（用于创建圆或部分圆）
        ctx.arc(211, 211, _this.turnplate.outsideRadius, angle, angle + arc, false);
        ctx.arc(211, 211, _this.turnplate.insideRadius, angle + arc, angle, true);
        ctx.stroke();
        ctx.fill();
        //锁画布(为了保存之前的画布状态)
        ctx.save();

        /** 绘制奖品 start **/
        ctx.fillStyle = "#E5302F";
        var text = _this.turnplate.prizeNames[i];
        var line_height = 17;
        //translate方法重新映射画布上的 (0,0) 位置
        ctx.translate(211 + Math.cos(angle + arc / 2) * _this.turnplate.textRadius, 211 + Math.sin(angle + arc / 2) * _this.turnplate.textRadius);

        //rotate方法旋转当前的绘图
        ctx.rotate(angle + arc / 2 + Math.PI / 2);

        /** 下面代码根据奖品类型、奖品名称长度渲染不同效果，如字体、颜色、图片效果。(具体根据实际情况改变) **/
        if (text.length > 6) {//奖品名称长度超过一定范围
          text = text.substring(0, 6) + "||" + text.substring(6);
          var texts = text.split("||");
          for (var j = 0; j < texts.length; j++) {
            ctx.fillText(texts[j], -ctx.measureText(texts[j]).width / 2, j * line_height);
          }
        }
        else {
          //在画布上绘制填色的文本。文本的默认颜色是黑色
          //measureText()方法返回包含一个对象，该对象包含以像素计的指定字体宽度
          ctx.fillText(text, -ctx.measureText(text).width / 2, 0);
        }
        //显示图片
        var img = document.getElementById("shanImg" + i);
        //半径
        var r = _this.turnplate.outsideRadius - 80;
        //圆心位置
        var bx = canvas.offsetLeft + _this.turnplate.outsideRadius;
        var by = canvas.offsetTop + _this.turnplate.outsideRadius;
        if (img) {
          img.setAttribute("x", Math.cos(angle + arc / 2) * r + bx);
          img.setAttribute("y", Math.sin(angle + arc / 2) * r + by);
          img.onload = function () {
            var x = this.getAttribute("x");
            var y = this.getAttribute("y");
            ctx.drawImage(this, x, y, 40, 40);
          }
        }
        //把当前画布返回（调整）到上一个save()状态之前
        ctx.restore();
        /** 绘制奖品 end **/
      }
    },
    /* 获取剩余抽奖次数 */
    getRaffleTimes() {
      var _this = this;
      raffleApi
        .getDrawRaffleTimes({ drawRaffleId: _this.raffleId, memberId: _this.userInfo.id })
        .then((res) => {
          if (res.suc == 1) {
            _this.remainTime = res.data.surplusTimes;
          } else {
            _this.remainTime = 0;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取我的及时抽奖中奖奖品 */
    getListAwardLogsByMemberId() {
      var _this = this;
      raffleApi
        .listAwardLogsByMemberId({
          code: _this.nodeCode,
          memberId: _this.userInfo.id,
          pageNo: 0,
          pageSize: 100,
        })
        .then((res) => {
          if (res.suc == 1) {
            _this.myPrizeList = res.data.list;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 抽奖 */
    startRaffle() {
      var _this = this;

      if (_this.turnplate.bRotate || _this.remainTime <= 0) {
        return;
      } else {
        _this.turnplate.bRotate = true;
        var params = {
          drawRaffleId: _this.raffleId,
          memberId: _this.userInfo.id,
          surplusTimes: _this.remainTime,
          freeFlag: _this.freeFlag,
        }
        raffleApi
          .doDrawRaffle(params)
          .then((res) => {
            if (res.suc == 1 && res.data.result == 1) {
              var index = _this.turnplate.prizeNames.indexOf(res.data.awardName);
              _this.rotateFn(index, res.data);
            } else {
              var len = _this.turnplate.prizeNames.length / 2;
              var index = Math.floor(Math.random() * len) * 2 + 1;
              _this.rotateFn(index, res.data);
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    rotateFn(itemIndex, data) {
      var _this = this;
      var angles = (itemIndex + 1) * (360 / _this.turnplate.prizeNames.length) - (360 / (_this.turnplate.prizeNames.length * 2));

      if (angles < 270) {
        angles = 270 - angles;
      } else {
        angles = 360 - angles + 270;
      }
      angles = 2160 * (_this.turnplate.rNum + 1) + angles;

      _this.oTurntable.style.transform = 'rotate(' + angles + 'deg)';

      clearTimeout(_this.timer);

      // 设置5秒后停止旋转,处理接口返回的数据
      _this.timer = setTimeout(function () {
        _this.turnplate.bRotate = !_this.turnplate.bRotate;
        _this.turnplate.rNum++;
        if (_this.freeFlag == 1) {
          _this.remainTime = 0;
        } else {
          _this.getRaffleTimes();
        }
        if (data.result == 1) {
          _this.$dialog.alert({ message: "恭喜您，获得" + data.awardName });
        } else {
          var i = Math.floor(Math.random() * _this.failedMsg2.length);
          _this.$dialog.alert({ message: _this.failedMsg2[i] });
        }
      }, 5000);
    },
    /* 现场兑奖/邮寄兑奖 tab切换 */
    onDJTabClick(index) {
      if (index == 0) {
        this.isMail = false;
      } else {
        this.isMail = true;
      }
    },
    /* 显示兑奖弹窗 */
    showAcceptHandler(data) {
      this.showAccept = true;
      this.curPrize = data;
    },
    /* 查看邮寄地址 */
    recipientInfo(data) {
      this.showAccept = true;
      this.curPrize = data;
    },
    /* 兑奖码兑奖 */
    acceptPrizeByCode() {
      var _this = this;
      var code = _this.curPrize.drawTime.substring(11, 19).replace(/:/g, '');
      if (_this.prizeCode == '') {
        _this.$toast({
          message: "请输入兑奖码!",
          position: "center",
        });
        return;
      } else if (code != _this.prizeCode) {
        _this.$toast({
          message: "您输入的兑奖码不正确",
          position: "center",
        });
        return;
      } else {
        raffleApi
          .acceptPrize({ awardLogsId: _this.curPrize.id })
          .then((res) => {
            if (res.suc == 1) {
              _this.$dialog
                .alert({ message: "兑奖成功！" })
                .then(() => {
                  _this.showAccept = false;
                  _this.prizeCode == '';
                  _this.curPrize.luckerStatus = 1;
                });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    /* 邮寄奖品兑奖 */
    acceptPrizeByMail() {
      var _this = this;
      if (_this.curPrize.addressee == '') {
        _this.$toast({
          message: "请输入收件人!",
          position: "center",
        });
        return;
      } else if (_this.curPrize.expressPhone == '') {
        _this.$toast({
          message: "您输入手机号!",
          position: "center",
        });
        return;
      } else if (_this.curPrize.expressAddress == '') {
        _this.$toast({
          message: "请输入收件地址!",
          position: "center",
        });
        return;
      } else if (!testMobilePhone(_this.curPrize.expressPhone)) {
        _this.$toast({
          message: "请填写正确的手机号码!",
          position: "center",
        });
        return;
      } else {
        raffleApi
          .awardSaveExpressInfo({
            awardLogsId: _this.curPrize.id,
            addressee: _this.curPrize.addressee,
            expressPhone: _this.curPrize.expressPhone,
            expressAddress: _this.curPrize.expressAddress,
          })
          .then((res) => {
            if (res.suc == 1) {
              _this.$dialog
                .alert({ message: "保存成功！" })
                .then(() => {
                  _this.showAccept = false;
                });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    /* 显示我的奖品 */
    showMyPrizeHandler() {
      this.showMyPrize = true;
      this.getListAwardLogsByMemberId();
    },
  },
  mounted() {
    if (!!this.detailInfo) {
      this.detail = deepClone(this.detailInfo);
      this.raffleId = this.detail.id;
      if (this.freeFlag == 1) {
        this.remainTime = 1;
      } else {
        this.getRaffleTimes();
      }
    }
    this.oTurntable = document.getElementById("wheelcanvas");
    this.oTurntable.style.transition = 'transform 5s ease';
    if (!!this.awards && this.awards.length > 0) {
      this.initRaffle();
    }
  }
};
</script>
<style scoped lang="scss">
.turntable_container {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  .turntable_box {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    min-height: 150vw;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 100% auto;
    background-image: url(~@/assets/images/raffle/dzp_bottom_bg.png);
    .turntable_mine_box {
      position: absolute;
      left: 0;
      top: 5%;
      z-index: 1;
      width: 100%;
      .turntable_bg {
        img {
          display: block;
          width: 100%;
        }
      }
      .turntable_canvas {
        position: absolute;
        left: 13.5%;
        top: 19%;
        z-index: 3;
        width: 73%;
        height: 73vw;
        max-height: 547.5px;
      }
      .turntable_point {
        position: absolute;
        left: 39%;
        top: 31.3%;
        z-index: 4;
        width: 22%;
        img {
          display: block;
          width: 100%;
        }
      }
      .turntable_btn {
        position: absolute;
        left: 38%;
        top: 36.5%;
        z-index: 5;
        width: 24%;
        height: 0;
        padding-bottom: 24%;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        .name {
          position: absolute;
          left: 0;
          top: 25%;
          width: 100%;
          height: 25%;
          text-align: center;
          font-size: 18px;
          span {
            align-items: center;
            display: flex;
          }
        }
        .tips {
          position: absolute;
          left: 0;
          top: 50%;
          width: 100%;
          text-align: center;
          font-size: 12px;
          transform: scale(0.8, 0.8);
          white-space: nowrap;
          .remain_times {
            color: #ffe21f;
          }
        }
      }
    }
    .turntable_title_img {
      position: absolute;
      left: 18.75%;
      top: 5%;
      z-index: 2;
      width: 62.5%;
      img {
        display: block;
        width: 100%;
      }
    }
    /* 查看我的中奖记录 */
    .my_prize_btn {
      position: absolute;
      left: 28.4375%;
      top: 74%;
      z-index: 6;
      width: 43.125%;
      img {
        display: block;
        width: 100%;
      }
    }
    /* btns 奖项设置和抽奖规则 */
    .operate_box {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 5;
      display: flex;
      width: 100%;
      height: 50px;
      padding: 5px 0;
      .operate_btn {
        flex: 1;
        height: 40px;
        line-height: 40px;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
        color: #df3435;
        font-size: 16px;
      }
    }
  }
  /* 我的奖品列表 */
  .my_prize_box {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
    .my_prize_title {
      padding: 15px 15px 10px;
      color: #ff8000;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      .tj-svg-icon {
        color: #ff8000;
        font-size: 20px;
      }
    }
    .prize_table_title {
      padding: 0 15px 10px;
      font-weight: bold;
      .time {
        display: inline-block;
        width: 100px;
        text-align: center;
      }
      .name {
        display: inline-block;
        width: 40%;
        text-align: center;
      }
      .btn_span {
        display: inline-block;
        width: calc(60% - 100px);
        text-align: center;
      }
    }
    .prize_content {
      width: 100%;
      height: calc(100% - 80px);
      padding: 0 15px 15px;
      overflow-x: hidden;
      overflow-y: auto;
      .prize_list {
        .prize_item {
          line-height: 32px;
          font-size: 14px;
          .time {
            display: inline-block;
            width: 100px;
            text-align: center;
          }
          .name {
            display: inline-block;
            width: 40%;
            text-align: center;
          }
          .btn_span {
            display: inline-block;
            width: calc(60% - 100px);
            text-align: center;
            .btn {
              padding: 5px 10px;
              background: orange;
              color: #fff;
              font-size: 12px;
              border-radius: 3px;
              &.btn_dis {
                background: gray;
                opacity: 0.5;
              }
              &.btn_recipient {
                background: orangered;
              }
            }
          }
        }
      }
    }
  }
  /* 兑奖弹窗 */
  .dj_box {
    .tabbar {
      /deep/.van-tabs__nav {
        background: #fff9d9;
      }
    }
    .dj_content {
      padding: 5px 15px 15px;
      .prize_code_box,
      .mail_address_box {
        width: 100%;
        height: auto;
        .inputInfoTitle {
          width: 100%;
          height: 40px;
          line-height: 40px;
          color: #ff8000;
          text-align: center;
          font-weight: bold;
          font-size: 20px;
          font-family: "Microsoft YaHei";
        }
        .prizeCode,
        .recipientName,
        .phoneDiv {
          height: 40px;
          line-height: 40px;
          label {
            width: 64px;
            font-size: 16px;
          }
          .codeInput,
          .nameInput,
          .phoneInput,
          .addressInput {
            width: 70%;
            height: 32px;
            outline: none;
            border: none;
            font-family: "Microsoft YaHei";
            text-indent: 5px;
            background: transparent;
            border-bottom: 1px solid #000;
            color: #000;
          }
        }
        .recipientAddress {
          height: 40px;
          line-height: 40px;
          label {
            width: 80px;
            font-size: 16px;
          }
          .addressInput {
            width: calc(70% - 16px);
            height: 32px;
            outline: none;
            border: none;
            font-family: "Microsoft YaHei";
            text-indent: 5px;
            background: transparent;
            border-bottom: 1px solid #000;
            color: #000;
          }
        }
        .tips {
          line-height: 40px;
          line-height: 40px;
          color: orangered;
          font-size: 13px;
        }
        .submitTijiao {
          display: block;
          width: 80%;
          height: 32px;
          line-height: 32px;
          background: #00c957;
          margin: 20px auto 0;
          color: #fff;
          text-align: center;
          font-size: 16px;
          font-family: "Microsoft YaHei";
          -moz-border-radius: 2px;
          -webkit-border-radius: 2px;
          border-radius: 2px;
          cursor: pointer;
          outline: none;
        }
      }
    }
  }
  /* 奖项设置 */
  .awards_box {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
    .awards_title {
      padding: 15px 15px 10px;
      color: #ff8000;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      .tj-svg-icon {
        color: #ff8000;
        font-size: 20px;
      }
    }
    .award_content {
      width: 100%;
      height: calc(100% - 50px);
      padding: 0 15px 15px;
      overflow-x: hidden;
      overflow-y: auto;
      .award_list {
        .award_item {
          margin-bottom: 10px;
          .award_title {
            margin-bottom: 5px;
            line-height: 24px;
            color: #646464;
            font-weight: bolder;
          }
          .award_img {
            padding: 0 10px;
            margin-bottom: 5px;
            img {
              display: block;
              max-width: 100%;
            }
          }
          .award_description {
            line-height: 24px;
            padding: 0 10px;
          }
        }
      }
    }
  }
  /* 抽奖规则 */
  .rules_box {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
    .rules_title {
      padding: 15px 15px 10px;
      color: #ff8000;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      .tj-svg-icon {
        color: #ff8000;
        font-size: 20px;
      }
    }
    .rule_content {
      width: 100%;
      height: calc(100% - 50px);
      padding: 0 15px 15px;
      overflow-x: hidden;
      overflow-y: auto;
      word-break: normal;
      color: #646464;
      line-height: 25px;
      /deep/img {
        display: block;
        max-width: 100%;
        height: auto;
        margin: 5px auto;
      }
    }
  }
}
</style>